<!-- Header  -->
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">
    <!-- Multiselect Dealer Dropdown -->
    <div class="col-lg-3 col-md-3 col-sm-6" *ngIf="dealerList?.length > 0">
      <div class="input-group">
        <ng-multiselect-dropdown
          style="width: 100%"
          [settings]="dropdownSettings"
          [data]="dealerList"
          placeholder="{{ 'lblSearchDealer' | translate }}"
          [(ngModel)]="selectedDealers"
          (ngModelChange)="onChangeDealer($event)"
        >
        </ng-multiselect-dropdown>
      </div>
    </div>

    <!-- Date Range Picker -->
    <div class="col-lg-3 col-md-3 col-sm-6">
      <div class="date">
        <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control"
          [(ngModel)]="selectedDate" (ngModelChange)="onDateRangeChanged($event)" />
      </div>
    </div>


    <!-- Clear Button -->
    <button
      type="submit"
      (click)="onClearFilter()"
      class="btn btn-primary btn-md"
      ngbTooltip="{{ 'lblClearFilters' | translate }}"
      placement="bottom"
      aria-label="Center Align"
    >
      <em class="far fa-times-circle font16 align-top"></em>
    </button>
    <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefreshClick()"
    aria-label="Center Align">
    <em class="fas fa-sync fa-lg"></em>
    </a>
    <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" >
      <!-- Excel -->
      <button type="button" (click)="exportAsXLSX()" 
          ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align" style="margin-right: 10px;">
          <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
      </button>
      <!-- PDF -->
      <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" 
          ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
          <em class="far fa-file fa-2x"></em>
          <span class="bdg">PDF</span>
      </button>
  </div>
  </div>
</div>

<!-- Body -->
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <!-- Body Header -->
        <div class="card-header d-flex justify-content-between" translate>
          lblCheckInUsage
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
            {{ totalCount }}
            &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>

        <!-- Body Content -->
        <div
          class="table-responsive max-h254"
          infinite-scroll
          [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle"
          [scrollWindow]="false"
          (scrolled)="onScrollDown()"
        >
         <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 35px" scope="col">#</th>
                <th scope="col" translate>lblDealerName</th>
                <th scope="col" sortable="totalAppointment" (sort)="onSort($event)" class="text-right" translate>
                  lblTotalAppointments
                </th>
                <th scope="col" sortable="smsSent" (sort)="onSort($event)" class="text-right" translate>
                  lblSMSSent
                </th>
                <th scope="col" sortable="smsNotSent" (sort)="onSort($event)" class="text-right" translate>
                  lblSMSNotSent
                </th>
                <th scope="col" sortable="checkInCompletedWithoutSms" (sort)="onSort($event)" class="text-right" translate>
                  lblCheckInCompletedWithoutSms
                </th>
                <th scope="col" sortable="checkInCompleted" (sort)="onSort($event)" class="text-right" translate>
                  lblCheckInCompleted
                </th>
                <th scope="col" sortable="checkInNotCompleted" (sort)="onSort($event)" class="text-right"
                  translate>
                   lblCheckInNotCompleted
                </th>
                 <th scope="col" sortable="checkInNotStarted" (sort)="onSort($event)" class="text-right"
                  translate>
                   lblCheckInNotStarted
                </th>
                <th scope="col" sortable="checkInPercentage" (sort)="onSort($event)"
                  class="text-right" translate>
                  lblCheckInPercentage
                </th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngIf="checkInUserList?.length > 0; else load_NotFound_Template">
                <tr *ngFor="let item of checkInUserList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <ngb-highlight [result]="item.dealerName"> </ngb-highlight>
                  </td>
                  <td class="text-right">
                    <div [ngClass]="{ 'disabled-div': item.totalAppointment === 0 }">
                      <ngb-highlight [result]="item.totalAppointment" style="cursor: pointer;" ngbTooltip="{{ 'lblTotalAppointments' | translate }}"
                      (click)="item.totalAppointment > 0 && onView(item, 'lblTotalAppointments', CheckInUsageReport.TotalAppointments)">
                      </ngb-highlight>
                    </div>
                  </td>
                  <td class="text-right">
                    <div [ngClass]="{ 'disabled-div': item.smsSent === 0 }">
                    <ngb-highlight [result]="item.smsSent" style="cursor: pointer;" ngbTooltip="{{ 'lblSMSSent' | translate }}"
                      (click)="item.smsSent > 0 && onView(item,'lblSMSSent',CheckInUsageReport.SmsSentAppointments)"
                      tooltipClass="custom-revert">
                    </ngb-highlight>
                  </div>
                  </td>
                  <td class="text-right">
                    <div [ngClass]="{ 'disabled-div': item.smsNotSent === 0 }">
                      <ngb-highlight [result]="item.smsNotSent" style="cursor: pointer;" ngbTooltip="{{ 'lblSMSNotSent' | translate }}"
                        (click)="item.smsNotSent > 0 && onView(item,'lblSMSNotSent',CheckInUsageReport.SmsNotSentAppointments)"
                        tooltipClass="custom-revert">
                      </ngb-highlight>
                    </div>
                  </td>
                  <td class="text-right">
                    <div [ngClass]="{ 'disabled-div': item.checkInCompletedWithoutSms === 0 }">
                    <ngb-highlight [result]="item.checkInCompletedWithoutSms" style="cursor: pointer;" ngbTooltip="{{ 'lblCheckInCompletedWithoutSms' | translate }}"
                     (click)="item.checkInCompletedWithoutSms > 0 && onView(item,'lblCheckInCompletedWithoutSms',CheckInUsageReport.CheckInCompletedWithoutSmsAppointments)"
                      tooltipClass="custom-revert">
                    </ngb-highlight>
                  </div>
                  </td>
                  <td class="text-right">
                    <div [ngClass]="{ 'disabled-div': item.checkInCompleted === 0 }">
                    <ngb-highlight [result]="item.checkInCompleted" style="cursor: pointer;" ngbTooltip="{{ 'lblCheckInCompleted' | translate }}"
                     (click)="item.checkInCompleted > 0 && onView(item,'lblCheckInCompleted',CheckInUsageReport.CheckInCompletedAppointments)"
                      tooltipClass="custom-revert">
                    </ngb-highlight>
                  </div>
                  </td>
                  <td class="text-right">
                    <div [ngClass]="{ 'disabled-div': item.checkInNotCompleted === 0 }">
                    <ngb-highlight [result]="item.checkInNotCompleted" style="cursor: pointer;" ngbTooltip="{{ 'lblCheckInNotCompleted' | translate }}"
                      (click)="item.checkInNotCompleted > 0 && onView(item,'lblCheckInNotCompleted',CheckInUsageReport.CheckInNotCompletedAppointments)"
                      tooltipClass="custom-revert">
                    </ngb-highlight>
                  </div>
                  </td>
                  <td class="text-right">
                    <div [ngClass]="{ 'disabled-div': item.checkInNotStarted === 0 }">
                    <ngb-highlight [result]="item.checkInNotStarted" style="cursor: pointer;"  ngbTooltip="{{ 'lblCheckInNotStarted' | translate }}"
                      (click)="item.checkInNotStarted > 0 && onView(item,'lblCheckInNotStarted',CheckInUsageReport.CheckInNotStartedAppointments)"
                      tooltipClass="custom-revert">
                    </ngb-highlight>
                  </div>
                  </td>
                  <td class="text-right">
                    <div>
                    <ngb-highlight [result]="item.checkInPercentage">
                    </ngb-highlight>
                    %
                  </div>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_NotFound_Template>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
